
/**
 * 業務閉塞エラー
 *
 * @export
 * @class BusinessStagnationResponse
 */
export class BusinessStagnationResponse extends Error {

  /** Apiレスポンス */
  error: any;

  /**
   * @param {*} apiResponse Apiレスポンス
   * @memberof BusinessStagnationResponse
   */
  constructor(apiResponse: any) {
    super(apiResponse);
    this.error = apiResponse;
  }
}